/**
 * Featured Collection Slider
 *
 * @namespace slider
 */

import $ from 'jquery'
import 'slick-carousel'

const selectors = {
    slider: '[data-product-slider]',
    item: '[data-product-slider-item]',
    nextArrow: '[data-product-slider-next]',
    prevArrow: '[data-product-slider-prev]',
    spinner: '[data-product-slider-spinner]'
}

const classes = {
    moving: 'slider__item--moving'
}

class ProductSlider extends HTMLElement {
    constructor() {
        super()

        this.$slider = $(selectors.slider, this)
        this.$items = $(selectors.item, this)
    }

    connectedCallback() {
        this.init()
    }

    init() {
        const options = {
            infinite: false,
            nextArrow: $(selectors.nextArrow),
            prevArrow: $(selectors.prevArrow),
            easing: 'swing',
            speed: 600,
            mobileFirst: true,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        centerMode: false
                    }
                }
            ]
        }

        this.$slider.on('init', () => {
            $(selectors.spinner, this.$container).hide()
        })
        this.$slider.on('beforeChange', () => {
            const animationEndEvents = [
                'webkitAnimationEnd',
                'mozAnimationEnd',
                'MSAnimationEnd',
                'oanimationend',
                'animationend'
            ].join(' ')

            this.$items.each(function () {
                const $item = $(this)
                $item.addClass(classes.moving).on(animationEndEvents, function () {
                    $item.removeClass(classes.moving)
                })
            })
        })

        this.$slider.slick(options)
    }
}

customElements.define('product-slider', ProductSlider)
